import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';
import SMCCheckboxContext from './SMCCheckboxContext';
import clsx from 'clsx';

/**
 * 
 * @param {object} params
 * @param {boolean} [params.disabled]
 * @param {function} [params.setCheckedValues]
 * @param {[any]} [params.checkedValues]
 * @param {object} [params.style]
 * @param {string} [params.className]
 * @param {node} [params.children]
 */
function SMCCheckboxGroup({
    disabled,
    setCheckedValues,
    checkedValues,
    style,
    className,
    children
}) {
    const classes = useStyles();
    const checkboxGroupContextValue = {
        checkedValues,
        setCheckedValues,
        disabled
    };

    return (
        <SMCCheckboxContext.Provider value={checkboxGroupContextValue}>
            <div className={clsx(classes.root, className)} style={style}>
                {children}
            </div>
        </SMCCheckboxContext.Provider>
    );
}

const useStyles = makeStyles({
    root: {
        lineHeight: '14px'
    }
})

SMCCheckboxGroup.propTypes = {
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    name: PropTypes.string,
    value: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.string,
    children: PropTypes.node
}

export default React.memo(SMCCheckboxGroup);